export const NB_POSTS_PER_PAGE = 30;
